module.exports = __webpack_public_path__ + "img/class_icon.2cdf4e13.png";